import React from 'react';
// import { Button, Input } from 'antd';
// import css from './css.less';
const Test = (props) => {
  return <div style={{ paddingTop: 300 }}>404 page not found</div>;
};
export default Test;
